import React from 'react'

import {
  BorderStyle,
  Box,
  Color,
  GridDisplay,
  JustifyContent,
  Text,
  withCitrusTheme,
} from '@gousto-internal/citrus-react'

const AVAILABLE_PORTIONS = [1, 2, 3, 4, 5]

const PortionButton = withCitrusTheme('button', (theme) => ({
  alignItems: 'center',
  appearance: 'none',
  backgroundColor: theme.color(Color.ColdGrey_50),
  borderColor: theme.color(Color.ColdGrey_100),
  borderRadius: '999px',
  borderStyle: BorderStyle.Solid,
  borderWidth: theme.border.width(0.5).borderWidth,
  boxSizing: 'border-box',
  color: theme.color(Color.ColdGrey_800),
  cursor: 'pointer',
  display: 'inline-flex',
  flexShrink: 0,
  font: 'inherit',
  height: 'clamp(52px, 15vw, 60px)',
  justifyContent: 'center',
  lineHeight: 1,
  padding: 0,
  width: 'clamp(52px, 15vw, 60px)',

  '&:hover': {
    backgroundColor: theme.color(Color.Secondary_50),
    borderColor: theme.color(Color.Secondary_400),
  },

  '&:focus-visible': {
    backgroundColor: theme.color(Color.Secondary_50),
    borderColor: theme.color(Color.Secondary_400),
    boxShadow: 'none',
    outline: 'none',
  },

  '&[aria-pressed="true"]': {
    backgroundColor: theme.color(Color.Secondary_50),
    borderColor: theme.color(Color.Secondary_400),
  },

  '&[aria-pressed="true"]:hover, &[aria-pressed="true"]:focus-visible': {
    backgroundColor: theme.color(Color.Secondary_100),
    borderColor: theme.color(Color.Secondary_500),
  },
}))

type FlexPortionOptionsProps = {
  selectedNumPortions: number
  onChange: (numPortions: number) => void
}

export const FlexPortionOptions = ({ selectedNumPortions, onChange }: FlexPortionOptionsProps) => {
  return (
    <Box
      display={GridDisplay.Grid}
      gap={3}
      gridTemplateColumns="repeat(5, minmax(0, 60px))"
      justifyContent={JustifyContent.SpaceBetween}
    >
      {AVAILABLE_PORTIONS.map((portionCount) => {
        const isSelected = portionCount === selectedNumPortions

        return (
          <PortionButton
            aria-label={`${portionCount} ${portionCount === 1 ? 'portion' : 'portions'}`}
            aria-pressed={isSelected}
            key={portionCount}
            onClick={() => onChange(portionCount)}
            type="button"
          >
            <Text size={2}>{portionCount}</Text>
          </PortionButton>
        )
      })}
    </Box>
  )
}
